<ng-container *transloco="let t;">
  <div class="p-mb-2" *ngIf="entries?.length > 0">
    <span *ngFor="let entry of entries" [ngClass]="{active: active.id === entry.id, content: entry.hasContent === true}" (click)="onSelect(entry)"><strong>{{ entry.label }}</strong></span>
  </div>
</ng-container>
